import { Bold as OriginalBold } from 'element-tiptap'
import LatexMenuButton from './MenuButton'

export default class LaTeX extends OriginalBold {
  get name() {
    return 'latex'
  }

  menuBtnView ({ isActive, commands, focus, editor }) {
    return {
      component: LatexMenuButton,
      componentProps: {
        isActive: false
      },
      componentEvents: {
        click: (callback) => {
          // 提供插入内容的回调函数
          callback((latexData) => {
            try {
              // 插入原始LaTeX代码
              const latexText = latexData.displayMode 
                ? `$$${latexData.formula}$$` 
                : `$${latexData.formula}$`
              
              // 创建带下划线样式的HTML内容
              const styledLatexHtml = `<span style="text-decoration: underline; text-decoration-color: rgba(102, 126, 234, 0.6); background-color: rgba(102, 126, 234, 0.08); border-radius: 4px; padding: 2px 4px; font-family: 'Consolas', 'Monaco', 'Courier New', monospace; font-size: 0.95em; border: 1px solid rgba(102, 126, 234, 0.2); margin: 0 2px; color: #5a67d8;" data-latex-formula="${latexText}">${latexText}</span>&nbsp;`
              
              // 尝试使用编辑器API插入HTML内容
              if (editor.commands && editor.commands.insertContent) {
                editor.commands.focus()
                const result = editor.commands.insertContent(styledLatexHtml)
                if (result) {
                  return
                }
              }
              
              // 备用方案：插入纯文本（保持兼容性）
              const { state, dispatch } = editor.view
              const { $from } = state.selection
              
              const textNode = state.schema.text(latexText + ' ')
              const tr = state.tr.insert($from.pos, textNode)
              dispatch(tr)
              
            } catch (error) {
              console.error('LaTeX插入失败:', error)
            }
          })
        }
      }
    }
  }
}
